import Api from '@/config/api';
import axios from 'axios';
import router from '@/router';
import store from '../store';

export default function (Vue) {
  // eslint-disable-next-line
  Vue.auth = {
    setToken(data) {
      localStorage.setItem('access_token', data.access_token);
      localStorage.setItem('refresh_token', data.refresh_token);
      localStorage.setItem('expiration', parseInt(data.expires_in) + (Date.now() / 1000));
    },
    async getToken() {
      const accessToken = localStorage.getItem('access_token');
      const expiration = localStorage.getItem('expiration');
      const refreshToken = localStorage.getItem('refresh_token');

      if (!accessToken || !expiration) return this.logout();
      // console.log(1);
      // console.log(Date.now() / 1000);
      // console.log(parseInt(expiration, 10));
      const check = (Date.now() / 1000) > parseInt(expiration, 10);

      if (check) {
        // console.log(2);
        if (((Date.now() / 1000) - parseInt(expiration, 10)) > 60) { return this.logout(); }

        await this.refreshToken(refreshToken);
        return localStorage.getItem('access_token');
      }
      return accessToken;
    },
    async refreshToken(refreshToken) {
      try {
        const response = await axios({
          method: 'post',
          url: Api.url(Api.endpoints.TOKEN),
          data: {
            client_id: Api.credentials.CLIENT_ID,
            client_secret: Api.credentials.CLIENT_SECRET,
            grant_type: Api.credentials.grantTypes.REFRESH_TOKEN,
            refresh_token: refreshToken,
          },
        });
        this.setToken(response.data);
        return response.data;
      } catch (error) {
        console.log(error);
        return this.logout();
      }
    },
    destroyToken() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('expiration');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('hasViewedScoutPopup');
      localStorage.clear();
    },

    isAuthenticated() {
      const accessToken = localStorage.getItem('access_token');
      // const token = await this.getToken();
      if (accessToken) return true;
      return false;
    },
    logout() {
      this.destroyToken();
      store.commit('clearAll');
      router.push({ name: 'login' });
    },
  };

  Object.defineProperties(Vue.prototype, {
    $auth: {
      get() {
        return Vue.auth;
      },
    },
  });
}
